export function normalizeBooleanSetting(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (
      normalized === '' ||
      normalized === '0' ||
      normalized === 'false' ||
      normalized === 'off' ||
      normalized === 'no' ||
      normalized === 'null' ||
      normalized === 'undefined'
    ) {
      return false;
    }

    if (
      normalized === '1' ||
      normalized === 'true' ||
      normalized === 'on' ||
      normalized === 'yes'
    ) {
      return true;
    }
  }

  return !!value;
}
